import { resources as PreliminaryCampaigns } from "./Preliminary";
import { resources as RegularCampaigns } from "./Regular";
import { resources as PaidCampaigns } from "./Paid";
import { resources as PreparatoryCourses } from "./Preparatory";
import { resources as HospitalContractCampaigns } from "./HospitalContracts";

// Hidden resources (isMenu: false) — spread into app/resources.js so their
// list/create/edit/show routes exist while the tabs page is the only menu item.
// Kept in its own module so Page.js can build the tabs from it without importing
// ./index.js (which imports Page.js — that would be a cycle).
export const campaignResources = [
  PreliminaryCampaigns,
  RegularCampaigns,
  PaidCampaigns,
  PreparatoryCourses,
  HospitalContractCampaigns,
];
